import React from "react";

const AssessmentDeploymentBreadcrumb = () => {
  return <span></span>;
};
export default AssessmentDeploymentBreadcrumb;
